export default el => {
	const btn = el.querySelector('.js-select-btn');
	const results = el.querySelector('.js-select-results');
	const inputs = el.querySelectorAll('input');

	const searchInput = el.querySelector('.js-select-search-input');
	const searchItems = el.querySelectorAll('.js-select-search-item');

	btn.addEventListener('click', () => {
		el.classList.toggle('active');
		btn.focus();
	})

	if (results) {
		inputs.forEach(input => {
			input.addEventListener('change', (e) => {
				updateResults();
			}) 
		})
	}

	const updateResults = () => {
		var checked = [];

		inputs.forEach(input => {
			if (input.checked) {
				var label = input.dataset.label;

				if (!label) {
					label = document.querySelector(`label[for="${input.id}"]`).innerHTML;
				}

				checked.push(label);
			}
		})

		results.innerHTML = checked.join(', ');

		el.classList.remove('active');
		btn.focus();
	}

	if (searchInput && searchItems) {
		searchInput.oninput = () => {
			searchItems.forEach(item => {
				const input = item.querySelector('input');
				const value = input.value.toLowerCase();
				const searchLabel = input.dataset.searchLabel.toLowerCase();

				var inactive = true;

				if (value.includes(searchInput.value.toLowerCase()) || searchLabel.includes(searchInput.value.toLowerCase())) {
					inactive = false;
				}

				item.classList[inactive ? 'add' : 'remove']('inactive');
			})
		}
	}

	document.addEventListener('click', (e) => {
		if (el !== e.target && !el.contains(e.target)) {
			el.classList.remove('active');
		}
	});

	document.addEventListener('keyup', (e) => {
		if (e.code !== "Tab") return;

		if (el !== document.activeElement && !el.contains(document.activeElement)) {
			el.classList.remove('active');
		}
	});
};
